module.exports = new __parcel__URL__("GoogleSheet.3f1e9841.svg").toString();